import React from 'react';

import styles from './ContactPopup.module.css';
import BasicPopup from '../../../Popups/BasicPopup/BasicPopup';
import GlobalModal from '../../../Popups/GlobalModal';
import useContactPopup from './useContactPopup';
import renderContent from './renderContent';

/**
 * ContactPopup Component
 * Displays contact information for a talent profile
 */
function ContactPopup({ isOpen, closePopup, talent }) {
    // Use custom hook to manage state and functionality
    const {
        option,
        message,
        sending,
        success,
        error,
        showContactInfo,
        showUpgradeModal,
        upgradeMessage,
        shouldShowContactPopup,
        hasTalentData,
        t,
        handleOptionChange,
        handleMessageChange,
        handlePopupClose,
        handleCloseUpgradeModal,
        handleSubmit
    } = useContactPopup({ isOpen, closePopup, talent });

    // Content to render
    const content = renderContent({
        hasTalentData,
        success,
        showContactInfo,
        talent,
        option,
        message,
        sending,
        error,
        t,
        handleOptionChange,
        handleMessageChange,
        handleSubmit,
        handlePopupClose
    });

    return (
        <>
            {shouldShowContactPopup && (
                <BasicPopup isOpen={isOpen} closePopup={handlePopupClose}>
                    <div className={styles.contactPopup}>
                        <h2 className={styles.title}>
                            {success 
                                ? t('ContactPopup.success_title') 
                                : showContactInfo 
                                    ? t('ContactPopup.contact_info') 
                                    : t('ContactPopup.contact_title')}
                        </h2>
                        
                        {content}
                    </div>
                </BasicPopup>
            )}
            
            <GlobalModal 
                show={showUpgradeModal}
                onClose={handleCloseUpgradeModal}
                title={t('upgrade.modal_title')}
                message={upgradeMessage}
                primaryButtonText={t('upgrade.upgrade_now')}
                secondaryButtonText={t('general.UI.cancel')}
                navigateTo="/subscriptions"
                secondaryButtonAction={handleCloseUpgradeModal}
            />
        </>
    );
}

export default ContactPopup; 